/**
 * Created by mac on 8/20/23
 */

const ResultsBarView = cc.Node.extend({
    avoidNode: "ResultsBarView",
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
    },

    init: function (game) {
        this.game = game;
        const score = game.score;
        const isDouble = this.isDouble = game.opponentScore !== undefined;
        const styles = cleverapps.styles.ResultsBar;

        this.setContentSize2(isDouble ? styles.double : styles.single);

        const bg = cleverapps.UI.createScale9Sprite(bundles.game.frames.score_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setAnchorPoint(0, 0);
        bg.setContentSize(this.width, this.height);
        this.addChild(bg);

        const person = this.createPerson(0);
        person.setAlignment(styles.person);
        this.addChild(person);

        if (game.goal) {
            const goalText = Messages.get("ResultsBar.Goal");
            const scoreBlockGoal = this.scoreBlock(score, ResultsBarView.GOAL, goalText, true);
            scoreBlockGoal.setAnchorPoint(0, 0);
            scoreBlockGoal.setAlignment(0, 0);
            this.addChild(scoreBlockGoal);
        } else {
            let labelText = Messages.get("ResultsBar.YourScore");
            const scoreBlock = this.scoreBlock(score, ResultsBarView.SOLO, labelText, true);
            scoreBlock.setAnchorPoint(0, 0);
            scoreBlock.setAlignment(0, 0);
            this.addChild(scoreBlock);

            if (isDouble) {
                const personOpponent = this.createPerson(1);
                personOpponent.setAlignment(styles.person2);
                this.addChild(personOpponent);

                labelText = Messages.get("ResultsBar.OpponentScore");
                const scoreBlockOpponent = this.scoreBlock(score, ResultsBarView.DOUBLE, labelText, false);
                scoreBlockOpponent.setAnchorPoint(0, 0);
                scoreBlockOpponent.setAlignment(person.width, 0);
                this.addChild(scoreBlockOpponent);

                scoreBlock.setAlignment(this.width / 2, 0);
            }
        }

        cleverapps.UI.onClick(this, this.addScore.bind(this), {
            interactiveScale: false
        });

        this.setVisible(false);
        this.game.on("showResults", this.animateShow.bind(this), this);
        this.game.on("hideResults", this.animateHide.bind(this), this);
    },

    scoreBlock: function (score, type, labelText, active) {
        const styles = cleverapps.styles.ResultsBar.scoreBlock[type];

        const block = new cc.Node();
        const width = type === ResultsBarView.VERSUS ? this.width / 2 : this.width;
        let blockWidth = width - cleverapps.styles.ResultsBar.personWidth;
        if (this.game.letterMission) {
            blockWidth -= cleverapps.styles.ResultsBar.info.width;
        }
        block.setContentSize2(blockWidth, this.height);
        block.setAnchorPoint(0.5, 0.5);
        block.setCascadeOpacityEnabled(true);

        const bg = cleverapps.UI.createScale9Sprite(bundles.game.frames.score_bg_results, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setAnchorPoint(0, 0);
        bg.setContentSize2(block.getContentSize());
        block.addChild(bg);

        cleverapps.styles.FONTS.SCORE_TEXT = type === ResultsBarView.VERSUS ? cleverapps.styles.FONTS.SCORE_TEXT_DOUBLE : cleverapps.styles.FONTS.SCORE_TEXT_SINGLE;
        const scoreView = new ScoreView(score);
        scoreView.setAlignment(styles.scoreView);
        block.addChild(scoreView);
        if (active) {
            cleverapps.aims.registerTarget("score", scoreView);
        }

        score.on("onUpdate", this.animateScore.bind(scoreView), this);

        const label = cleverapps.UI.generateOnlyText(labelText, cleverapps.styles.FONTS[type === ResultsBarView.VERSUS ? "RESULTS_DOUBLE_TEXT" : "RESULTS_TEXT"]);
        label.setAlignment(styles.label);
        block.addChild(label);

        if (type === ResultsBarView.GOAL) {
            const goalText = `/${this.game.goal.target}`;
            const labelGoal = cleverapps.UI.generateOnlyText(goalText, cleverapps.styles.FONTS.GOAL_TEXT);
            labelGoal.setAlignment(styles.goal);
            block.addChild(labelGoal);
        }

        if (!active) {
            bg.setVisible(false);
            block.setOpacity(100);
        }

        return block;
    },

    animateShow: function (silent) {
        this.setVisible(true);

        if (silent) {
            return;
        }

        const styles = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? cleverapps.styles.ResultsBar.showAnimation.vertical : cleverapps.styles.ResultsBar.showAnimation.horizontal;

        this.setCascadeOpacityEnabledRecursively(true);
        this.setOpacity(0);

        this.runAction(
            new cc.Sequence(
                new cc.MoveBy(0, styles.dx, styles.dy),
                new cc.Spawn(
                    new cc.FadeIn(0.3),
                    new cc.MoveTo(0.3, this.x, this.y)
                )
            )
        );
    },

    createPerson: function (id) {
        const person = new cc.Node();
        person.setAnchorPoint(0.5, 0.5);

        const frame = new cc.Sprite(bundles.avatars.frames.frame_user);
        person.setContentSize(frame.getContentSize());

        const avatar = new cc.Sprite(id === 1 ? bundles.avatars.frames[`opponent_${Math.floor(Math.random() * 3 + 1)}`] : bundles.avatars.frames.avatar_user);
        avatar.setAlignment(person.width / 2, person.height / 2);
        person.addChild(avatar);

        frame.setAlignment(person.width / 2, person.height / 2);
        person.addChild(frame);
        return person;
    },

    animateHide: function () {
        this.setCascadeOpacityEnabledRecursively(true);

        const styles = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? cleverapps.styles.ResultsBar.showAnimation.vertical : cleverapps.styles.ResultsBar.showAnimation.horizontal;
        this.runAction(
            new cc.Spawn(
                new cc.FadeOut(0.3),
                new cc.MoveBy(0.3, styles.dx, styles.dy)
            )
        );
    },

    addScore: function () {
        Game.currentGame.score.addPoints(50);
    },

    animateScore: function (points) {
        this.scoreView.runAction(StandartAnimations.countTo(this.scoreView, points, {
            duration: 0.4,
            sound: bundles.game.urls.yatzy_check
        }));
        this.scoreView.fitTo(cleverapps.styles.UI.ScoreView.maxWidth);
    }
});

cleverapps.styles.UI.ScoreView.maxWidth = 150;

cleverapps.styles.ResultsBar = {
    single: {
        width: 900,
        height: 165
    },

    double: {
        width: 900,
        height: 165
    },

    showAnimation: {
        horizontal: {
            dx: 100,
            dy: 0
        },
        vertical: {
            dx: -100,
            dy: 0
        }
    },

    personWidth: 175,

    scoreBlock: {
        goal: {
            scoreView: {
                x: { align: "center", dx: -10 },
                y: { align: "center", dy: 2 }
            },

            label: {
                x: { align: "center", dx: -150 },
                y: { align: "center", dy: -5 }
            },

            goal: {
                x: { align: "center", dx: 130 },
                y: { align: "center", dy: 5 }
            }
        },
        single: {
            scoreView: {
                x: { align: "center", dx: 140 },
                y: { align: "center", dy: 0 }
            },

            label: {
                x: { align: "center", dx: -64 },
                y: { align: "center", dy: 0 }
            }
        },

        double: {
            scoreView: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: -20 }
            },

            label: {
                x: { align: "center", dx: -0 },
                y: { align: "center", dy: 40 }
            }
        }
    },

    person: {
        x: { align: "right" },
        y: { align: "center" }
    },

    person2: {
        x: { align: "left" },
        y: { align: "center" }
    },

    info: {
        width: 225
    }
};

ResultsBarView.SOLO = "single";
ResultsBarView.VERSUS = "double";
ResultsBarView.GOAL = "goal";